function replaceRewardsWidget(){
  console.log('function called')
  // Remove USA Rewards
  var rewardsUSA = document.querySelector('.ebook-page-form-usa')
  rewardsUSA.classList.add('no-display')

  // Add UK Rewards
  var rewardsUK = document.querySelector('.ebook-page-form-uk')
  rewardsUK.classList.remove('no-display')
}

function waitForElement(id, callback){
    var loops = setInterval(function(){
      // console.log("waiting for contact us button")
        if(document.querySelector(id)){
            clearInterval(loops);
            callback();
        }
    }, 100);
}



var lastLink = document.querySelector('.nav-desktop__tier-1-item:last-of-type')

var lastLinkHREF = lastLink.children[0].href

if (lastLinkHREF.search('offers-gb') != -1){
console.log('we here waiting for referral widget replace')
  waitForElement(".ebook-page-form-usa",replaceRewardsWidget);

  
  
} else{
  // console.log('no yoooo')
}